import React, { useState } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import { Form } from "react-bootstrap";
import { FormControl } from "../";

const FormControlDollar = ({
  field,
  form,
  precision,
  size = "sm",
  isWarning = false,
  ...rest
}) => {
  const [focusClass, setFocusClass] = useState("");
  const disabled = rest.disabled;
  // rest.value = parseFloat(rest.value)?.toFixed(2);
  const onDollarInputFocus = () => {
    setFocusClass("focus");
  };

  // console.log("psdcsd", parseFloat(rest.value)?.toFixed(2));

  const onDollarInputBlur = (e) => {
    const { handleBlur } = rest;
    if (e.target.value)
      e.target.value = precision
        ? parseFloat(e.target.value)?.toFixed(precision)
        : parseFloat(e.target.value)?.toFixed(2);
    setFocusClass("");
    handleBlur(e);
  };

  return (
    <FormControl {...field} {...form} {...rest} size={size}>
      <InputGroup
        className={`input-dollar-wrapper ${focusClass}`}
        style={{ maxWidth: "200px", flexWrap: "nowrap" }}
      >
        <InputGroup.Prepend>
          <InputGroup.Text
            className={`${
              !isWarning ? "input-dollar " : "input-dollar-warning"
            } ${disabled ? "disabled" : ""}`}
          >
            $
          </InputGroup.Text>
        </InputGroup.Prepend>
        <Form.Control
          {...field}
          {...rest}
          style={{
            borderLeft: "0px",
            borderRadius: "0px 5px 5px 0px",
            flexGrow: 0.2,
            borderColor: isWarning ? "#fa9715" : null,
            className: isWarning ? "input-dollar-warning" : "input-dollar",
          }}
          onFocus={onDollarInputFocus}
          onBlur={onDollarInputBlur}
        />
      </InputGroup>
    </FormControl>
  );
};

export default FormControlDollar;
